import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

export class CustumShouldReuseRouteFalseForTaskDetail implements RouteReuseStrategy  {
  /* eslint-disable @typescript-eslint/no-unused-vars */
  retrieve( route: ActivatedRouteSnapshot ): DetachedRouteHandle | null {
    return null;
  }

  /* eslint-disable @typescript-eslint/no-unused-vars */
  shouldAttach( route: ActivatedRouteSnapshot ): boolean {
    return false;
  }

  /* eslint-disable @typescript-eslint/no-unused-vars */
  shouldDetach( route: ActivatedRouteSnapshot ): boolean {
    return false;
  }

  shouldReuseRoute( future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot ): boolean {
    if (  future['_routerState'].url.indexOf("/workflow/") === 0 && future['_routerState'].url.endsWith("/details")
         && curr['_routerState'].url.indexOf("/workflow/") === 0 && curr['_routerState'].url.endsWith("/details"))
    {
      return false;
    } else {
      return future.routeConfig === curr.routeConfig;
    }
  }

  /* eslint-disable @typescript-eslint/no-unused-vars */
  /* eslint-disable @typescript-eslint/no-empty-function */
  store( route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null ): void {
  }

}
